import type { GlideFunctionalRenderer } from "common/components/uis";
import { styled } from "../styled-components";
import { definedMapWithDefault } from "collection-utils";
import { asString, asBoolean } from "common/components/component-helpers";
import { useForce } from "hooks/use-force";
import { useForceValueProducers } from "hooks/use-value-producers";
import { SeparatorSpacing } from "common/generator/components/separator-spacing";

const sizeMapping: { [size: string]: number } = { default: 4, small: 8, medium: 16, large: 32 };

const HR = styled.div<{ size: string }>`
    display: flex;
    flex-direction: column;

    padding: ${p => sizeMapping[p.size]}px ${p => p.theme.pageMarginMedium}px;

    & > .sep-line {
        background-color: ${p => p.theme.fgColorDark};
        opacity: 0.15;
        height: 1px;
    }
`;

export const SeparatorMaterialRenderer: GlideFunctionalRenderer = p => {
    const { getValueProducers, ctx } = p;
    const [force] = useForce();
    const [[sizePV, showLinePV]] = useForceValueProducers(getValueProducers, force, ctx);
    const size = definedMapWithDefault(sizePV, SeparatorSpacing.Default, asString);
    const showLine = definedMapWithDefault(showLinePV, true, asBoolean);

    return (
        <HR data-test="app-hr" size={size}>
            {showLine && <div className="sep-line" role="separator" />}
        </HR>
    );
};
